import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-product-doc-price-dialog',
  templateUrl: './product-doc-price-dialog.component.html',
  styleUrls: [ './product-doc-price-dialog.component.scss' ]
})
export class ProductDocPriceDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();
  public entityForm: FormGroup;   // store User Form
  public isEdit: boolean = false;

  constructor (
    private fb: FormBuilder,
     public matDialogRef: MatDialogRef<ProductDocPriceDialogComponent>,
     @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    //
    // console.log("doc: " + JSON.stringify(this.data));

    if(this.data.id) 
      this.isEdit = true;

    this.entityForm = this.createForm(this.data)
  }

  ngOnInit () {
  }

  createForm (data: any) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      doc: new FormControl(data.doc, [ Validators.required ]),
    });
    return form
  }

}
